import { ClassEnum, COLOR_SCHEME_OPTIONS } from '@/constants/enum';
import { widgetSettingSelector } from '@/redux/slice/widget.slice';
import { Dispatch, SetStateAction, useMemo } from 'react';
import { useSelector } from 'react-redux';
import RadioInput from '../../../Header/components/RadioInput';
import { PickupLocationItemStyled } from '@/modules/WidgetPreview/styled/element-styled';

interface IProps {
  location?: {
    value: string;
    label?: string;
    address: string;
  };
  locationId?: string;
  setLocationId: Dispatch<SetStateAction<string | undefined>>;
}

const PickupLocationItem = ({ location, locationId, setLocationId }: IProps) => {
  const widgetSettings = useSelector(widgetSettingSelector);
  const isSelected = useMemo(() => location?.value === locationId, [location?.value, locationId]);
  const isDarkTheme = useMemo(() => widgetSettings.colorScheme === COLOR_SCHEME_OPTIONS.DARK, [widgetSettings.colorScheme]);

  return (
    <PickupLocationItemStyled
      className={ClassEnum.PickupLocationItem}
      bgColor={isSelected ? (isDarkTheme ? '#1a1a1a' : '#fafafa') : ''}
      borderColor={isSelected ? (isDarkTheme ? '#ffffff' : '#171717') : isDarkTheme ? '#ffffff' : '#1717171a'}
      color={isSelected ? (isDarkTheme ? '#ffffff' : '#020912') : isDarkTheme ? '#ffffff' : '#020912'}
      hoverBgColor={isSelected ? '' : isDarkTheme ? '#1a1a1a' : '#fafafa'}
      borderRadius={widgetSettings.sizes.borderRadius}
      onClick={() => setLocationId(location?.value!)}
    >
      <div style={{ marginTop: '4px' }}>
        <RadioInput isChecked={isSelected} />
      </div>
      <div className={ClassEnum.PickupLocationItemContainer}>
        <span className={ClassEnum.PickupLocationItemTitle}>{location?.label}</span>
        <span className={ClassEnum.PickupLocationItemDescription}>{location?.address}</span>
      </div>
    </PickupLocationItemStyled>
  );
};

export default PickupLocationItem;
